module.exports = __webpack_public_path__ + "img/oem1.a6780b7f.png";